import React, { useContext, useState, useEffect, useRef } from 'react';
import { Button, Switch, Input, Form, Select } from 'antd'
import GeneralContext from '../../context/GeneralContext/GeneralContext';
import { ERegExp } from '../../enums/ERegExp'
import { displayMessage } from '../../helpers/messages'

const { Option } = Select

export default function ClientFilters(props) {
    const [form] = Form.useForm()

    const {
        mobile_mode,
        windowWidth
    } = useContext(GeneralContext)

    useEffect(() => {
        form.setFieldsValue('by_active', true)
    }, [])



    const handleOnClearFilter = () => {
        form.resetFields()
    }

    const onSubmitForm = (values) => {
        props.handleOnSearchClients(values)
    }
    const windowBreakpoint = windowWidth < 800 //px

    return (

        <div
            style={
                {
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    padding: 0,
                    // marginBottom: 15,
                    height: mobile_mode ? '' : props.filterHeight + 'vh',
                    minHeight: mobile_mode ? '400px' : '',
                    color: 'white',
                    overflow: 'hidden',
                    border: '1px solid lightgrey',
                }
            }
        >
            <div className='flex justify-between p-2 bg-appian-blue gap-1'>
                <span className='self-center font-bold text-lg text-fit-gray-600 flex-1 text-center'>Filtros da Consulta</span>
            </div>

            <div style={{ display: 'flex', flex: 1, flexDirection: 'column', justifyContent: 'space-between' }} className={'bg-fit-gray-100'}>

                <Form
                    form={form}
                    className={`flex flex-1 flex-col ss:flex-row min-w-fit gap-4 flex-wrap ${mobile_mode ? 'justify-center' : ''}`}
                    layout='inline'
                    onFinish={onSubmitForm}
                >
                    <div style={{ display: 'flex', flexDirection: mobile_mode || windowWidth < 1650 ? 'column' : 'row', justifyContent: 'start', width: '100%', marginLeft: mobile_mode ? 0 : 5 }}>

                        <div style={{ display: 'flex', flexDirection: mobile_mode || windowWidth < 1400 ? 'column' : 'row', gap: 5, marginTop: 12 }}>
                            <div className='flex gap-2 items-center' style={{ display: 'flex', flexDirection: mobile_mode ? 'column' : 'row' }}>
                                <span className='font-bold text-fit-red-900 ss:w-[130px]'>{displayMessage('COMPANY_NAME')}:</span>
                                <Form.Item initialValue={''} className='m-0 flex-1 w-[300px]' name={'by_name'} label={''}>
                                    <Input className='ss:w-[300px] flex-1' />
                                </Form.Item>
                            </div>
                            <div className='flex gap-2 items-center' style={{ display: 'flex', flexDirection: mobile_mode ? 'column' : 'row', marginLeft: mobile_mode || windowWidth < 1400 ? 0 : 15 }}>
                                <span className={`font-bold text-fit-red-900 ss:w-[${windowWidth < 1400 ? '130' : '90'}px]`}>{displayMessage('COMPANY_DOCUMENT')}:</span>
                                <Form.Item
                                    initialValue={''}
                                    className='m-0 flex-1 w-[300px]'
                                    name={'by_cnpj'}
                                    label={''}
                                    rules={[{ pattern: ERegExp.ONLY_HAVE_NUMBERS.regexp, message: displayMessage('INVALID_INPUT_DATA') }]}
                                >
                                    <Input className='ss:w-[300px] w-full flex-1' maxLength={14} />
                                </Form.Item>
                            </div>
                        </div>
                        <div className='flex gap-2 items-center' style={{ display: 'flex', flexDirection: mobile_mode ? 'column' : 'row', marginLeft: mobile_mode || windowWidth < 1650 ? 0 : 15, marginTop: mobile_mode || windowWidth > 1650 ? 0 : 5 }}>
                            <span className={`font-bold text-fit-red-900 ss:w-[${windowWidth < 1650 ? '130' : '80'}px]`}>{displayMessage('SITUATION')}:</span>
                            <Form.Item initialValue={''} className='m-0 flex-1' name={'by_active'} label={''}>
                                {/* <Switch checkedChildren={displayMessage('IS_ACTIVE')} unCheckedChildren={displayMessage('IS_INACTIVE')} defaultChecked={true} /> */}
                                <Select className={`w-full min-w-[300px] ss:w-[300px]`} allowClear placeholder={displayMessage('ALL_M')} >
                                    <Option key={0} value={true}>{displayMessage('ACTIVE')}</Option>
                                    <Option key={1} value={false}>{displayMessage('INACTIVE')}</Option>
                                </Select>
                            </Form.Item>
                        </div>
                    </div>
                </Form>

                <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', padding: 8, alignItems: 'flex-end', justifyContent: windowBreakpoint ? 'center' : 'flex-end' }}>
                    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: windowBreakpoint ? 'center' : 'flex-end', paddingLeft: !windowBreakpoint && 8, alignItems: 'flex-end', borderLeft: !windowBreakpoint && '1px solid lightgrey', gap: 8 }}>
                        <Button
                            onClick={() => form.submit()}
                            type="primary"
                            style={{ width: 200, fontWeight: 'bold', borderRadius: 7 }}
                        >
                            Consultar
                        </Button>

                        <Button
                            style={{ width: 200, fontWeight: 'bold', borderRadius: 7 }}
                            type="primary"
                            danger={true}
                            onClick={handleOnClearFilter}
                        >
                            Limpar filtros
                        </Button>
                    </div>
                </div>
            </div>

        </div >


    )
}


